// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3e9ae89","239":"f582cf82","732":"25467003"}[chunkId] + ".chunk.js";
};